import lianxin from '@/assets/js/lianxinConfig.js'
// 平台标识配置
// 默认是袋鼠
global.brandConfig = {
  logo: require("@/assets/images/register/logo.png"),
  defaultOrgImg: require('@/assets/images/default-logo-7.png'),
  bannerOrg: require('@/assets/images/banner-org.png'),
  bannerOrgV2: require('@/assets/images/lianxin/defaultOrgBanner.png'),
  bannerPackage: require('@/assets/images/banner-package.png'),
  daishuPhone: '4001-0755-70',
  daishuwebsite: 'www.daishujiankang.com',
  daishuwebsitePhone: '4001075570',
  companyName: '袋鼠健康',
  detailCompanyName: "袋鼠健康(海南)互联网医院有限公司",
  parentCompany: "讯康信息技术（深圳）有限公司",
  reportBanner: require('@/assets/images/report-unscramble-bg-2.png'),
  agreeText1: "1、本平台提供的体检服务以及体检报告解读服务的运营主体为袋鼠健康（海南）互联网医院有限公司，本平台的技术服务由讯康信息技术（深圳）有限公司提供！",
  shareParams: {
    title: '袋鼠健康',
    desc: '专业预约体检，就上袋鼠健康。',
    link: document.URL,
    imgUrl: 'http://public-10006067.file.myqcloud.com/imgpath/WechatIMG395.png',
    implementRequest: true // 是否重新获取设置分享配置
  },
  showDaishu: true, // 是否展示袋鼠标识
  dmi: true, // 是否展示d米
  medicalCard: true, // 是否展示卡券
  noSearchResult: require("@/assets/images/no-search-result.jpg"), // 搜索页缺省图
}

function getUrlSpecifiedParam(paraName) {
  let url = document.location.toString()
  let replace = url.match(/#(\S*)\?/) // 获取#到？之间的一个数组
  replace && (url = url.replace(`#${replace[1]}?`, '?')) // 把url#后面的name值去掉，保留？后面的参数

  let arrObj = url.split('?')
  if (arrObj.length >= 3) {
    url = ''
    for (let i = 0, len = arrObj.length; i < len; i++) {
      url += i === 0 ? arrObj[0] + '?' : '&' + arrObj[i]
    }
    arrObj = url.split('?')
  }
  if (arrObj.length > 1) {
    let arrPara = arrObj[1].split(/[&#]/)
    let arr
    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split('=')
      if (arr != null && arr[0] == paraName) {
        return arr[1]
      }
    }
    return ''
  } else {
    return ''
  }
}

const channelConfig = {
  "004_01_0010_0001_01": lianxin // 莲心健康
}

  ;
(() => {
  // 有的微信版本过低，没有replaceAll方法
  if (!String.prototype.replaceAll) {
    String.prototype.replaceAll = function () {
      var args = arguments;
      var searchValue = args[0];
      var newValue = args[1];
      //如果搜索的字符与替换的新字符有不存在的，则不做任何操作，返回原字符串
      if (!searchValue || !newValue) return this.toString();
      var regParam = "g";
      if (searchValue instanceof RegExp) { //如果是正则，需判断是否传入 g i m等标示
        //global: true //不用处理，默认就是全局
        searchValue.ignoreCase ? (regParam += "i") : null;
        searchValue.multiline ? (regParam += "m") : null;
      }
      //这里用到了正则的构造函数
      var reg = new RegExp(searchValue, regParam);

      return this.replace(reg, newValue);
    }

  }
  let channel = getUrlSpecifiedParam('channel') || sessionStorage.getItem('channel');
  if (channelConfig[channel]) {
    brandConfig = {
      ...brandConfig,
      ...channelConfig[channel]
    }
  }
})()
